const sizeObj = {
    XXS: 'Extra Extra Small',
    XS: 'Extra Small',
    S: 'Small',
    M: 'Medium',
    L: 'Large',
    XL: 'Extra Large',
    XXL: 'Extra Extra Large',
    'S/M': 'Small-Medium',
    'M/L': 'Medium-Large',
    'L/XL': 'Large-Extra Large'
};

export const manageSizeName = (tempSize) => {
    if (sizeObj[tempSize]) {
        return sizeObj[tempSize];
    }
    return null;
};


export const extractRange = (tempSize) => {

    tempSize = tempSize.toString()
    // Match N followed by Y or M (e.g., "2Y" or "3M")
    let matchSingle = tempSize.match(/^(\d+)([YM])$/);
    // Match N-N followed by Y or M (e.g., "0-3Y" or "1-5M")
    let matchRange = tempSize.match(/^(\d+)-(\d+)([YM])$/);
    const unitMap = {
        Y: "year",
        M: "month"
    };

    if (matchSingle) {
        return `${parseInt(matchSingle[1], 10)} ${unitMap[matchSingle[2]]}`
    }

    if (matchRange) {
        return `${parseInt(matchRange[1], 10)} to ${parseInt(matchRange[2], 10)} ${unitMap[matchRange[3]]}`
    }

    // Not a valid format
    return null;
}